import React from 'react'
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import UserListContainer from '../../containers/goalsetting/UserListContainer';


const GoalDeptUserPage = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', }}>
            <Box sx={{ width: "400px", mr: 1 }}>
                <UserListContainer />
            </Box>
            <Box sx={{ flexGrow: 1 }}><Outlet /></Box>
        </Box>

    )
}

export default GoalDeptUserPage